
<div class="cat-switch">
    <p *ngIf="categoriesService.categoriesLoaded | async as categoriesLoaded; else categoriesLoader">
        <mpro-toggle-switch [disabled]="!categoriesLoaded" [state]="isOn" [disabled]="!enableToggle" (stateChange)="enableCategories($event)"></mpro-toggle-switch>
        Categories Consumer Demand
    </p>
    <ng-template #categoriesLoader>
        <mpro-loading></mpro-loading>
    </ng-template>
</div>
